import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { FlyoutMenuComponent } from '../../../components/flyout-menu/flyout-menu.component';
import { FlyoutMenuItemDirective } from '../../../components/flyout-menu/flyout-menu-item.directive';
import { FlyoutMenuOverlayPosition, MenuPanelItem } from '../../../domain/menu.domain';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { MenuNavigationBaseComponent } from '../menu-navigation-base.component';
import { MenuTopGlobalNavigationItemComponent } from '../top-navigation-item/top-navigation-item.component';

/**
 * The Global Navigation Menu
 *
 * This is the global navigation menu for menu component
 */
@Component({
  selector: 'td-wb-menu-global-navigation',
  templateUrl: './global-navigation.component.html',
  styleUrls: ['./global-navigation.component.scss'],
  imports: [
    TranslatePipe,
    MenuTopGlobalNavigationItemComponent,
    FlyoutMenuComponent,
    FlyoutMenuItemDirective,
    TranslateDirective
  ]
})
export class MenuGlobalNavigationComponent extends MenuNavigationBaseComponent {

  /**
   * Navigation menu
   */
  readonly navigationMenu = input<Array<MenuPanelItem>>(undefined);

  // TODO Deprecate
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly FlyoutMenuOverlayPosition: typeof FlyoutMenuOverlayPosition = FlyoutMenuOverlayPosition;
}
